/**
 * juliette-page-context — Conscience de page de Juliette.
 *
 * Coeur de la couche contextuelle (chantier "presence ambiante") : a partir du
 * pathname courant, determine quel ROLE Juliette joue et si elle se manifeste
 * de maniere PROACTIVE (whisper) sur cet ecran.
 *
 * Decision produit (brainstorm 08/06) : le proactif est limite au CRM et a la
 * Messagerie. Le Tableau de bord garde son briefing Systeme 1 existant (pas de
 * doublon de whisper). Partout ailleurs, l'orbe reste presente mais REACTIVE
 * seulement (l'utilisateur l'ouvre, elle ne l'interrompt pas).
 */

export type JuliettePage = "crm" | "messages" | "dashboard" | "other";

export type JulietteRole = "analyste" | "reponse" | "briefing" | "aucun";

export interface JulietteContext {
  /** Page metier reconnue (sert a router le comportement proactif). */
  page: JuliettePage;
  /** Casquette de Juliette sur cet ecran. */
  role: JulietteRole;
  /** true => Juliette peut lever la main (whisper) spontanement ici. */
  proactive: boolean;
}

function isUnder(pathname: string, base: string): boolean {
  return pathname === base || pathname.startsWith(`${base}/`);
}

export function getJuliettePageContext(pathname: string): JulietteContext {
  if (isUnder(pathname, "/crm")) {
    return { page: "crm", role: "analyste", proactive: true };
  }
  if (isUnder(pathname, "/messages")) {
    return { page: "messages", role: "reponse", proactive: true };
  }
  if (pathname === "/") {
    return { page: "dashboard", role: "briefing", proactive: false };
  }
  return { page: "other", role: "aucun", proactive: false };
}
